import { Routes } from '@angular/router';
import { assinaturaAtivaGuard } from './guards/assinatura-ativa.guard';
import { authGuard } from './guards/auth.guard';
import { telemedicinaEmBreveGuard } from './guards/telemedicina-em-breve.guard';
import { guestGuard } from './guards/guest.guard';
import { landingGuard } from './guards/landing.guard';
import { MinhasAssinaturasPlanoPage } from './pages/minhas-assinaturas-plano.page';

export const routes: Routes = [
  {
    path: 'indicacao/:codigo',
    loadComponent: () =>
      import('./pages/indicacao/indicacao.page').then((m) => m.IndicacaoPage),
  },
  {
    path: 'convite-assinatura',
    loadComponent: () =>
      import('./pages/invite-accept/invite-accept.page').then((m) => m.InviteAcceptPage),
  },
  {
    path: 'home',
    pathMatch: 'full',
    redirectTo: 'tabs/home',
  },
  {
    path: '',
    pathMatch: 'full',
    canActivate: [landingGuard],
    loadComponent: () => import('./pages/landing/landing.page').then((m) => m.LandingPage),
  },
  {
    path: 'auth',
    canActivate: [guestGuard],
    loadChildren: () => import('./pages/auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  {
    path: 'onboarding',
    loadChildren: () =>
      import('./pages/onboarding/onboarding.routes').then((m) => m.ONBOARDING_ROUTES),
  },
  {
    path: 'legal/termos-de-uso',
    loadComponent: () =>
      import('./pages/legal/legal-document.page').then((m) => m.LegalDocumentPage),
    data: { doc: 'termos' },
  },
  {
    path: 'legal/politica-privacidade',
    loadComponent: () =>
      import('./pages/legal/legal-document.page').then((m) => m.LegalDocumentPage),
    data: { doc: 'privacidade' },
  },
  {
    path: 'minhas-assinaturas',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/minhas-assinaturas/minhas-assinaturas.page').then((m) => m.MinhasAssinaturasPage),
  },
  {
    path: 'minhas-assinaturas/pagamento',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/minhas-assinaturas-pagamento/minhas-assinaturas-pagamento.page').then(
        (m) => m.MinhasAssinaturasPagamentoPage
      ),
  },
  {
    path: 'minhas-assinaturas/historico',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/minhas-assinaturas-historico.page').then(
        (m) => m.MinhasAssinaturasHistoricoPage
      ),
  },
  {
    path: 'minhas-assinaturas/plano',
    canActivate: [authGuard],
    component: MinhasAssinaturasPlanoPage,
  },
  {
    path: 'minhas-assinaturas/plano/cartao',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/minhas-assinaturas-plano-cartao/minhas-assinaturas-plano-cartao.page').then(
        (m) => m.MinhasAssinaturasPlanoCartaoPage
      ),
  },
  {
    path: 'estabelecimentos',
    pathMatch: 'full',
    redirectTo: '/tabs/estabelecimentos',
  },
  {
    path: 'estabelecimentos/cartao-virtual',
    canActivate: [authGuard, assinaturaAtivaGuard],
    loadComponent: () =>
      import('./pages/cartao-virtual/cartao-virtual.page').then(
        (m) => m.CartaoVirtualPage
      ),
  },
  {
    path: 'estabelecimentos/indicacoes',
    canActivate: [authGuard, assinaturaAtivaGuard],
    loadComponent: () =>
      import('./pages/indicacao-estabelecimento/indicacao-estabelecimento.page').then(
        (m) => m.IndicacaoEstabelecimentoPage
      ),
  },
  {
    path: 'candidatura-vendedor',
    canActivate: [authGuard, assinaturaAtivaGuard],
    loadComponent: () =>
      import('./pages/candidatura-vendedor/candidatura-vendedor.page').then(
        (m) => m.CandidaturaVendedorPage
      ),
  },
  {
    path: 'estabelecimentos/:id',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/estabelecimento-detalhe/estabelecimento-detalhe.page').then(
        (m) => m.EstabelecimentoDetalhePage
      ),
  },

  {
    path: 'notificacoes',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/notificacoes/notificacoes.page').then((m) => m.NotificacoesPage),
  },
  {
    path: 'menu/termos',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/legal/termos-politicas-hub.page').then((m) => m.TermosPoliticasHubPage),
  },
  {
    path: 'menu',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/configuracoes/menu/menu.page').then((m) => m.MenuPage),
  },
  {
    path: 'dados-pessoais',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/configuracoes/dados-pessoais/dados-pessoais.page').then(
        (m) => m.DadosPessoaisPage,
      ),
  },
  {
    path: 'endereco',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/configuracoes/endereco/endereco.page').then((m) => m.EnderecoPage),
  },
  {
    path: 'fale-conosco',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/fale-conosco/fale-conosco.page').then((m) => m.FaleConoscoPage),
  },
  {
    path: 'redefinir-senha',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/redefinir-senha/redefinir-senha.page').then((m) => m.RedefinirSenhaPage),
  },
  {
    path: 'telemedicina/especialidades',
    canActivate: [authGuard, telemedicinaEmBreveGuard],
    loadComponent: () =>
      import('./pages/telemedicina/especialidades/especialidades.page').then(
        (m) => m.TelemedicinaEspecialidadesPage,
      ),
  },
  {
    path: 'telemedicina/profissionais',
    canActivate: [authGuard, telemedicinaEmBreveGuard],
    loadComponent: () =>
      import('./pages/telemedicina/profissionais/profissionais.page').then(
        (m) => m.TelemedicinaProfissionaisPage,
      ),
  },
  {
    path: 'telemedicina/confirmacao',
    canActivate: [authGuard, telemedicinaEmBreveGuard],
    loadComponent: () =>
      import('./pages/telemedicina/confirmacao/confirmacao.page').then(
        (m) => m.TelemedicinaConfirmacaoPage,
      ),
  },
  {
    path: 'telemedicina/videochamada',
    canActivate: [authGuard, telemedicinaEmBreveGuard],
    loadComponent: () =>
      import('./pages/telemedicina/videochamada/videochamada.page').then(
        (m) => m.TelemedicinaVideochamadaPage,
      ),
  },
    {
    path: 'relatorios-comissoes',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./pages/relatorios-comissoes/relatorios-comissoes.page').then(
        (m) => m.RelatoriosComissoesPage,
      ),
  },

  {
    path: '',
    loadChildren: () => import('./tabs/tabs.routes').then((m) => m.routes),
  },
  {
    // URL inexistente (deep link inválido, reload em rota removida): volta à
    // raiz, onde o landingGuard decide o destino conforme a sessão.
    path: '**',
    redirectTo: '',
  },
];

